export const currentYear = () => {
  const date = new Date().getFullYear();
  return date;
};
